import type React from 'react';

const Break: React.FC = () => <br />;
export default Break;
